<template>
  <b-row id="privile-history-detail" class="px-1">
    <b-col cols="8">
      <div class="d-flex w-100 mb-2">
        <div class="privilege-label">Reference</div>
        <b-form-input
          class="w-70"
          id="ref-privilege"
          placeholder="Reference"
          v-model="reference"
          disabled
        />
      </div>
      <div class="d-flex w-100 mb-2">
        <div class="privilege-label">Name (EN)</div>
        <b-form-input
          class="w-70"
          id="nameEn-privilege"
          placeholder="Privilege Name"
          v-model="nameHistoryEn"
          disabled
        />
      </div>
      <div class="d-flex w-100 mb-2">
        <div class="privilege-label">Name (TH)</div>
        <b-form-input
          class="w-70"
          id="nameTh-privilege"
          placeholder="Privilege Name"
          v-model="nameHistoryTh"
          disabled
        />
      </div>
    </b-col>
    <b-col cols="4" class="d-flex justify-content-end">
      <img-zoom-content :imageUrl="imageUrl" />
    </b-col>
  </b-row>
</template>

<script>
import ImgZoomContent from "./ImgZoomContent.vue";
export default {
  props: {
    reference: { type: String, default: "" },
    nameHistoryEn: { type: String, default: "" },
    nameHistoryTh: { type: String, default: "" },
    imageUrl: { type: String, default: "" },
  },
  components: { ImgZoomContent },
};
</script>

<style scoped>
@import "~@/assets/css/pages/privilege/privilege-history.css";
</style>